import { computed } from 'mobx';

export default class QCRuleModel {
  static modelName = 'QCRuleModel';
  id;
  store;

  constructor(store, qcRule) {
    this.store = store;
    this.id = +qcRule.id;
    this.type = +qcRule.type;
    this.type_name = qcRule.type_name;
    this.description = qcRule.description;
    this.start_date = qcRule.start_date;
    this.end_date = qcRule.end_date;
    this.applicable_months = qcRule.applicable_months;
    this.qc_flag = qcRule.qc_flag;
    this.threshold = qcRule.threshold || {
      lower_threshold: '',
      upper_threshold: '',
    };
    this.step = qcRule.step || {
      max_change: '',
      interval: '',
    };
    this.constant = qcRule.constant || {
      threshold: '',
      interval: '',
    };
    this.value_check = qcRule.value_check || {
      reference: '',
    };
  }

  @computed get asJson() {
    return {
      id: +this.id,
      type: +this.type,
      type_name: this.type_name,
      description: this.description,
      start_date: this.start_date,
      end_date: this.end_date,
      applicable_months: this.applicable_months,
      qc_flag: this.qc_flag,
      threshold: this.threshold,
      step: this.step,
      constant: this.constant,
      value_check: this.value_check,
    };
  }

  updateFromJson(json) {
    this.id = +json.id;
    this.type = +json.type;
    this.type_name = json.type_name;
    this.description = json.description;
    this.start_date = json.start_date;
    this.end_date = json.end_date;
    this.applicable_months = json.applicable_months;
    this.qc_flag = json.qc_flag;
    this.threshold = json.threshold || {
      lower_threshold: '',
      upper_threshold: '',
    };
    this.step = json.step || {
      max_change: '',
      interval: '',
    };
    this.constant = json.constant || {
      threshold: '',
      interval: '',
    };
    this.value_check = json.value_check || {
      reference: '',
    };
  }
}



// WEBPACK FOOTER //
// ./src/models/QCRuleModel.js